import React from 'react';
import { Box, Typography } from '@mui/material';
import { BRAND, COMPANY, brown, orange, useEnglishPage } from './enCommon';

/* 영문 회사소개 (/en/introduce). 한국어 회사소개의 뜻을 줄여 옮겼다. 글을 고치면 prerender 의 EN_ABOUT 도 */
export const EN_ABOUT_TITLE = 'About Us | EK Hana Tour';
export const EN_ABOUT_DESC =
  'EK Hana Tour (EK Tour Co., Ltd.) is a licensed travel agency in Korea providing charter buses for groups, tours and airport transfers.';

const PARAGRAPHS = [
  'We always do our best for the satisfaction and happiness of our customers.',
  'Over the years we have grown together with our customers. Even as competition in the industry grows, putting our customers first has always been our way of doing business.',
  'Trust and honesty. They are the most important values for any company, and the foundation on which we run ours. We want to be known as a company our customers and staff can rely on.',
  'We are not a company that only looks after profit. As a member of society, we want to help build a better community.',
  'We promise to do everything we can so that every passenger enjoys a safe and pleasant trip.',
];

export default function EnCompany({ companyData = {} }) {
  useEnglishPage(EN_ABOUT_TITLE, EN_ABOUT_DESC);

  return (
    <Box component='main' lang='en' sx={{ maxWidth: 860, mx: 'auto', px: { xs: 2, md: 3 }, py: { xs: 3, md: 6 } }}>
      <Typography sx={{ color: orange, fontWeight: 800, textAlign: 'center' }}>Making our customers happy, together.</Typography>
      <Typography component='h1' sx={{ mt: 1, fontSize: { xs: 28, md: 40 }, fontWeight: 800, color: brown, textAlign: 'center' }}>
        TRUST &amp; HONEST!
      </Typography>
      <Box sx={{ mt: 3 }}>
        {PARAGRAPHS.map((p) => (
          <Typography key={p} sx={{ mt: 2, color: brown, lineHeight: 1.8, fontSize: { xs: 15, md: 17 } }}>{p}</Typography>
        ))}
        <Typography sx={{ mt: 2, color: brown, fontSize: { xs: 15, md: 17 } }}>Thank you.</Typography>
      </Box>
      <Box sx={{ mt: 4, textAlign: 'right', color: brown }}>
        <Typography>CEO, {COMPANY}</Typography>
        {companyData.adminName && <Typography sx={{ fontWeight: 800, fontSize: 20 }}>{companyData.adminName}</Typography>}
      </Box>
      <Box sx={{ mt: 5, p: 2.5, bgcolor: '#FFFDF6', borderRadius: 2, color: brown }}>
        <Typography component='h2' sx={{ fontWeight: 800, fontSize: 18 }}>Company information</Typography>
        <Typography sx={{ mt: 1 }}>{BRAND} — {COMPANY}</Typography>
        <Typography>Licensed general travel agency (domestic and international travel), Republic of Korea</Typography>
        {companyData.businessNum && <Typography>Business registration no. {companyData.businessNum}</Typography>}
      </Box>
    </Box>
  );
}
